import Pusher from "pusher-js";
import { Action, HandRaise, IssueDetails } from "@/interfaces/meeting/details";
import { EventTypes } from "../socket/meeting";

let _publicChannel: string;
let _privateChannel: string;
let _client: Pusher;

export enum Targets {
  SERVER,
  PUBLIC,
  PRIVATE
}

export enum ActionTypes {
  MAIN_CHAT = "main chat",
  EVENT_VIDEO_SHOW = "video show",
  EVENT_VIDEO_PAUSE = "video pause",
  EVENT_VIDEO_RESUME = "video resume",
  SHOW_IMAGE = "show image",
  SHOW_URL = "show url",
  SHOW_CART = "show cart",
  START_MEETING = "meeting start",
  END_MEETING = "meeting end",
  SPIN = "spin",
  SHARE_SCREEN = "screen share",
  SHOW_GIPT = "show gipt"
}

export enum FeedbackTypes {
  VIMEO = "vimeoStatus"
}

export const setChannels = (publicChannel: string, privateChannel: string) => {
  _publicChannel = publicChannel;
  _privateChannel = privateChannel;
};

export const setClient = (client: Pusher) => (_client = client);

export const sendAction = (action?: Action | null) => {
  _client.send_event(EventTypes.ACTION, action || {}, _publicChannel);
};

export const sendFeedback = (details: { [key: string]: any }) =>
  _client.send_event(EventTypes.FEEDBACK, details, _privateChannel);

export const sendRaiseHand = (details: HandRaise) =>
  _client.send_event(EventTypes.RAISE_HAND, details, _publicChannel);

export const sendUnraiseHand = (details: HandRaise) =>
  _client.send_event(EventTypes.UNRAISE_HAND, details, _publicChannel);

export const sendHandReset = () =>
  _client.send_event(EventTypes.HAND_RESET, {}, _publicChannel);

export const sendTncAccepted = (direction: boolean) =>
  _client.send_event(EventTypes.TNC_ACCEPTED, { direction }, _publicChannel);

export const sendNameUpdate = (sender: string) =>
  _client.send_event(EventTypes.NAME_UPDATE, { sender }, _publicChannel);

export const sendUpdateChat = (sender: string) =>
  _client.send_event(EventTypes.UPDATE_CHAT, { sender }, _publicChannel);

export const sendUpdateCart = () =>
  _client.send_event(EventTypes.UPDATE_CART, {}, _publicChannel);

export const sendPublicSocket = (eventType: EventTypes, data: unknown) =>
  _client.send_event(eventType, data, _publicChannel);

export const sendSignatoryChanged = (signatoryId: string) =>
  _client.send_event(
    EventTypes.SIGNATORY_CHANGED,
    { signatoryId },
    _publicChannel
  );

export const sendSignatureChanged = () =>
  _client.send_event(EventTypes.SIGNATURE_CHANGED, {}, _privateChannel);

export const sendGiptFormChanged = () =>
  _client.send_event(EventTypes.GIPT_FORM_CHANGED, {}, _privateChannel);

export const sendGiptPackagesChanged = () =>
  _client.send_event(EventTypes.GIPT_PACKAGES_CHANGED, {}, _privateChannel);

export const sendReportAVIssue = (details: IssueDetails) =>
  _client.send_event(EventTypes.REPORT_AV_ISSUE, details, _publicChannel);

export const sendAVReset = () =>
  _client.send_event(EventTypes.ISSUE_RESET, {}, _publicChannel);

export const sendRetractReport = (details: IssueDetails) =>
  _client.send_event(EventTypes.RETRACT_ISSUE_REPORT, details, _publicChannel);

export const sendEndMeeting = () =>
  _client.send_event(EventTypes.END_MEETING, {}, _publicChannel);
